module.exports = __webpack_public_path__ + "img/box-gift.5f144f0.png";